import { resolveApplicantResubmitInfo } from './requirementRedirect';

export const hasExistingApplication = (application) => Boolean(application && application.id);

export const resolveApplicantAccess = (email, messages = [], application = null) => {
  const resubmit = resolveApplicantResubmitInfo(email, messages, application);
  if (resubmit?.step) {
    return { mode: 'resubmit', resubmit, application };
  }

  if (hasExistingApplication(application)) {
    return { mode: 'waiting', application };
  }

  return { mode: 'apply', application: null };
};
